import { ListenerOptions, MediaBreakPoints } from './use-media-query'
import useMediaQuery from './use-media-query'

type Props = {
  children: (arg0: MediaBreakPoints) => JSX.Element
} & ListenerOptions

/*
 * Render prop version can be used in a similar manner
 * as the custom Hook. This allows the MediaQuery to also
 * be used in class based components since Hooks are only allowed
 * in functional components.
 * For functional components, prefer the useMediaQuery named export
 */
MediaQuery.defaultProps = {
  custom: undefined,
  mobile: false,
  tablet: false,
}

function MediaQuery(props: Props) {
  const { custom, mobile, tablet } = props
  const breakpoints = useMediaQuery({ custom, mobile, tablet })

  return props.children(breakpoints)
}

export { default as useMediaQuery } from './use-media-query'
export default MediaQuery
